





















import { defineComponent, reactive, onBeforeMount } from '@vue/composition-api'

import { UserState, NoticeState } from '@/types/store'
import { UserRole } from '@/types/user'
import useVuex from '@/utils/useVuex'

import Layout from '@/components/organisms/common/Layout.vue'
import { NoticesTable } from '@/components/organisms/notices'

export default defineComponent({
  name: 'Notices',
  components: { Layout, NoticesTable },
  setup(props, context) {
    const store = context.root.$store
    const state = reactive({
      notices: useVuex<NoticeState['notices']>(
        context,
        () => store.getters['notice/notices'],
      ),
      total: useVuex<NoticeState['total']>(
        context,
        () => store.getters['notice/total'],
      ),
      isNoticesLoading: useVuex<NoticeState['isNoticesLoading']>(
        context,
        () => store.getters['notice/isNoticesLoading'],
      ),
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
    })

    onBeforeMount(() => {
      store.dispatch('notice/getNotices')
    })

    const create = async () => {
      await store.dispatch('notice/setNewNotice')
      context.root.$router.push('/notice-edit').catch(() => {
        /*2連打した際のerrorを無視*/
      })
    }

    return { state, UserRole, create }
  },
})
